angular.module('impactx.tender').controller('TenderLotCSCDetailCtrl', [
    '$scope',
    'dataGen',
    'selectedListItems',
    '$routeParams',
    'BackService',
    '$mdToast',
    'ConfirmationService',
    'ToolbarService',
    TenderLotCSCDetailCtrl
]);

function TenderLotCSCDetailCtrl($scope, dataGen, selectedListItems, $routeParams, BackService, $mdToast, ConfirmationService, ToolbarService) {
    var self = this;
    var selectedItem = selectedListItems.getFirstSelectedItem();

    self.tenderId = selectedItem ? selectedItem.tenderId : $routeParams.id;

    self.updateData = function (tenderId, lotId, lotSupplierId, lotBuyerId, cscId) {
        var dataObj = {
            tenderId: tenderId,
            lotId: lotId,
            lotSupplierId: lotSupplierId,
            lotBuyerId: lotBuyerId,
            cscId: cscId
        };

        if (tenderId && tenderId > 0) {
            dataGen.getData($scope, dataObj, "/tender/tenderlotcsc/detail").then(function () {
                defineButtons();
            });
        }
    };

    if (selectedItem) {
        self.updateData(selectedItem.tenderId, selectedItem.lotId, selectedItem.lotSupplierId, selectedItem.lotBuyerId, selectedItem.cscId);
    }
    else {
        self.updateData($routeParams.id, 0, 0, 0, 0);
    }


    $scope.updateDataForLot = function (selected) {
        if (selected && (selected.id != $scope.oldSelectedLotId)) {
            $scope.oldSelectedLotId = selected.id;
            self.updateData(self.tenderId, selected.id, 0, 0, 0);
        }
        else {
            if (!selected) {
                $scope.oldSelectedLotId = 0;
                self.updateData(self.tenderId, 0, 0, 0, 0);
            }
        }
    };

    $scope.updateCSCDataForSupplier = function (selected) {
        if (selected && $scope.data.tenderlotcsc.lotName.selected && $scope.data.tenderlotcsc.lotBuyerName.selected && (selected.id != $scope.oldSelectedLotSupplierId)) {
            $scope.oldSelectedLotSupplierId = selected.id;
            self.updateData(self.tenderId, $scope.data.tenderlotcsc.lotName.selected.id, selected.id, $scope.data.tenderlotcsc.lotBuyerName.selected.id, 0);
        }
        else {
            if (!selected && $scope.data.tenderlotcsc.lotName.selected) {
                $scope.oldSelectedLotSupplierId = 0;
                self.updateData(self.tenderId, $scope.data.tenderlotcsc.lotName.selected.id, 0, $scope.data.tenderlotcsc.lotBuyerName.selected.id, 0);
            }
        }
    };

    $scope.updateCSCDataForBuyer = function (selected) {
        if (selected && $scope.data.tenderlotcsc.lotName.selected && $scope.data.tenderlotcsc.lotSupplierName.selected && (selected.id != $scope.oldSelectedLotBuyerId)) {
            $scope.oldSelectedLotBuyerId = selected.id;
            self.updateData(self.tenderId, $scope.data.tenderlotcsc.lotName.selected.id, $scope.data.tenderlotcsc.lotSupplierName.selected.id, selected.id, 0);
        }
        else {
            if (!selected && $scope.data.tenderlotcsc.lotName.selected) {
                $scope.oldSelectedLotBuyerId = 0;
                self.updateData(self.tenderId, $scope.data.tenderlotcsc.lotName.selected.id, $scope.data.tenderlotcsc.lotSupplierName.selected.id, 0, 0);
            }
        }
    };

    self.save = function () {
        var dataObj = {
            tenderLotCSC: $scope.data.tenderlotcsc
        };
        return dataGen.postAsForm($scope, dataObj, "/tender/tenderlotcsc/save").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    self.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(self.delete, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };

    self.delete = function () {
        var dataObj = {
            tenderId: $scope.data.tenderlotcsc.tenderId,
            lotId: $scope.data.tenderlotcsc.lotId,
            lotSupplierId: $scope.data.tenderlotcsc.lotSupplierId,
            lotBuyerId: $scope.data.tenderlotcsc.lotBuyerId,
            cscId: $scope.data.tenderlotcsc.contractId
        };
        dataGen.postAsForm($scope, dataObj, "/tender/tenderlotcsc/delete").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData,
                    disableExpression: {valueFunction: disableSave, error: $scope.data.tenderlotcsc.contractError}
                }
            },
            {
                label: $scope.trns.delete,
                action: self.deleteDialog,
                type: 'dialogaction',
                condition: isEditable
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.tenderlotcsc.lotName.readOnly;
    }

    function disableSave() {
        return $scope.data.tenderlotcsc.contractError;
    }
}